import { Storage } from "./tools";
import { useCommon } from "@/store/useCommon";
import pinia from '@/store';
import { getAllLangApi } from '@/api/common';
import { getAgentProtocolApi, getDocumentDownloadApi } from '@/api/operating';
import { getSysDictListApi } from '@/api/live';
import { getBrandListApi, getPlatformListApi, getVodGenresOptionsApi, getLangOptionsApi } from '@/api/vodNew';
import { getcountryListApi } from '@/api/live';
const storeCommon = useCommon(pinia);
const user = computed(() => storeCommon.userData); // 缓存数据

const cachesData = ref({});
export const PrefixInteger = (num, length) => {
  return ("0000000000000000" + num).substr(-length);
}; // 获取品牌列表数据，并缓存到 Pinia，避免重复请求。

export const useBrandsByUser = async params => {
  const cachedBrands = storeCommon.cacheData.brandsByUser;

  if (Array.isArray(cachedBrands)) {
    return cachedBrands;
  }

  const res = await getBrandListApi(user.value.cid);

  if (res.code == '0') {
    const brands = Array.isArray(res.data) ? res.data.map(item => ({ ...item,
      prefixName: PrefixInteger(item.id, 3) + '-' + item.name,
      cid: item.id,
      value: item.id
    })) : [];
    storeCommon.setCacheData({ ...storeCommon.cacheData,
      brandsByUser: brands
    });
    return brands;
  }

  return [];
}; // 获取平台数据

export const usePlatformsByUser = async params => {
  let ids = user.value.cid && user.value.cid.join(',');
  let data = Storage.sessionGet('Platforms');

  if (data) {
    return data;
  } else {
    let res = await getPlatformListApi(user.value.cid);

    if (res.code == '0') {
      let resData = res.data.map(item => ({ ...item,
        prefixName: PrefixInteger(item.id, 3) + '-' + item.name,
        pid: item.id,
        value: item.id
      }));
      Storage.sessionSet('Platforms', resData);
      return resData;
    }

    return [];
  }
}; // 获取所有语言

export const useLanguages = async () => {
  let langs = Storage.sessionGet('langs');

  if (langs) {
    return langs;
  } else {
    let {
      code,
      data
    } = await getAllLangApi();

    if (code === '0') {
      let resData = data.map(item => ({
        label: item.name,
        value: item.id,
        symbol: item.symbol
      }));
      Storage.sessionSet('langs', resData);
      return resData;
    }

    return [];
  }
}; // 获取点播相关的语言

export const useVodLanguages = async () => {
  try {
    let langs = Storage.sessionGet('vodLangs');

    if (langs) {
      return langs;
    } else {
      let {
        code,
        data
      } = await getLangOptionsApi();

      if (code == '0') {
        let resData = data.map(item => ({ // label: item.name,
          // value: item.key,
          // labelValue: item.name
          ...item,
          labelValue: item.name,
          label: item.name,
          value: item.code
        }));
        Storage.sessionSet('vodLangs', resData);
        return resData;
      } else {
        return [];
      }
    }
  } catch (error) {}
}; // 获取所有国家

export const useCountryList = async () => {
  let langs = Storage.sessionGet('countries');

  if (langs) {
    return langs;
  } else {
    let {
      code,
      data
    } = await getcountryListApi();

    if (code == '0') {
      let resData = data.map(item => ({
        label: item.label,
        value: item.label,
        abbValue: item.value
      }));
      Storage.sessionSet('countries', resData);
      return resData;
    }

    return [];
  }
}; // 获取分辨率

export const useBroadCastList = async () => {
  let broadCast = Storage.sessionGet('broadCast');

  if (broadCast) {
    return broadCast;
  } else {
    let {
      code,
      data
    } = await getSysDictListApi('broadcast_type');

    if (code == '0') {
      let newData = data.map(item => {
        return { ...item,
          broadCastType: item.label
        };
      });
      Storage.sessionSet('broadCast', newData);
      return newData;
    }

    return [];
  }
}; // 获取文档下载列表

export const useDocumentDownloadList = async () => {
  let downloadList = Storage.sessionGet('downloadList');

  if (downloadList) {
    return downloadList;
  } else {
    let {
      code,
      data
    } = await getDocumentDownloadApi({});

    if (code === '0') {
      let resData = data.map((item, index) => {
        return { ...item,
          no: index + 1
        };
      });
      Storage.sessionSet('downloadList', resData);
      return resData;
    }

    return [];
  }
}; // 获取关联分类列表

export const useGenresList = async (language, type) => {
  let GenresList = Storage.sessionGet('GenresList') || {};

  if (GenresList && GenresList[type] && GenresList[type][language]) {
    return GenresList[type][language];
  } else {
    let {
      code,
      data
    } = await getVodGenresOptionsApi({
      language
    });

    if (code == '0') {
      if (!GenresList.hasOwnProperty(type)) {
        GenresList[type] = {};

        if (!GenresList[type].hasOwnProperty(language)) {
          GenresList[type][language] = data;
        }
      } else {
        if (!GenresList[type].hasOwnProperty(language)) {
          GenresList[type][language] = data;
        }
      }

      Storage.sessionSet('GenresList', GenresList);
      return data;
    }

    return [];
  }
}; // 获取协议

export const useAgentProtocolList = async () => {
  let agentProtocolList = Storage.sessionGet('agentProtocolList');

  if (agentProtocolList) {
    return agentProtocolList;
  } else {
    let {
      code,
      data
    } = await getAgentProtocolApi();

    if (code === '0') {
      Storage.sessionSet('agentProtocolList', data);
      return data;
    }

    return [];
  }
};